<template>
    <div>
        <!-- // * CONTENT TITLE (GENERIC) -->
        <v-row class="contenttitle grey lighten-2 white--text py-4 mx-0 pl-4 pr-2 d-flex align-center white">
            <app-text category="content-title">
                <div class="d-flex align-center">
                    <span class="pl-2 d-inline-block text-truncate">{{ form.name }} </span>
                </div>
            </app-text>
            <v-spacer></v-spacer>
        </v-row>

        <!--Body-->
        <div>

            <!--Tabs-->
            <!-- // * TABS MENU (CUSTOM) -->
            <v-tabs class="border-bottom-grey" v-model="tabs" height="53" show-arrows>
                <v-tabs-slider color="red" background-color="black"></v-tabs-slider>
                <v-tab href="#overview" class="white"><v-icon class="mr-2">icons8-form</v-icon> <span class="caption">Overview</span></v-tab>
            </v-tabs>

            <!--Tab content-->
            <v-tabs-items class="appbackground" v-model="tabs">
                <v-tab-item value="overview" class="pa-0">
                    <v-row class="mt-4" no-gutters>
                        <!-- // * DESCRIPTION -->
                        <v-col class="px-3" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <app-text category="tab-title">Fire Roll Call Overview<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text>
                            <app-text category="tab-text" v-if="GET_help">Use the form below to edit the Fire Roll Calls details</app-text>
                            <v-divider class="my-4"/>
                        </v-col>
                        <!-- // * ACTION BAR -->
                        <v-col class="pa-0 d-flex pl-2 pr-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <appbutton :label="$t(`buttons.undelete`)" v-if="formMode !== 'New' && form.delete !== undefined" icon="icons8-process" type="purple"  class="mr-1" @click.native="undeleteItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                            <appbutton :label="$t(`buttons.delete`)" v-if="formMode !== 'New' && form.delete === undefined" icon="icons8-trash" type="secondary"  class="mr-1" @click.native="deleteItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                            <appbutton :label="$t(`buttons.edit`)" v-if="formMode !== 'New'" icon="icons8-edit-property" type="secondary"  class="mr-1" @click.native="editItem()" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly" />
                            <v-spacer />
                            <appbutton :label="$t(`buttons.cancel`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-cancel" type="grey darken-2"  class="mr-1" @click.native="cancelItem()" showlabel="xlOnly" />
                            <appbutton :label="$t(`buttons.save`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-save" type="info"  class="mr-0" @click.native="validateForm()" showlabel="xlOnly" />                                                
                        </v-col>                    
                    </v-row>

                    <!--Counters | Form | Register-->
                    <!-- // * FORM -->  
                    <v-form ref="form">
                        <v-row class="mt-2 px-2" no-gutters>
                            <!--Duration-->
                            <!--Counters-->
                            <div class="frcr-counter-container mx-1">
                            
                                <!--Time taken-->
                                <!--Not for small screens-->
                                <div v-if="$vuetify.breakpoint.width > 424" class="ffrcr-counter" width="40">
                                    <app-text class="grey--text" category="text-small">TIME TAKEN</app-text>
                                    <app-text class="grey--text" category="text-default-bold"> {{ computedTimeTaken }} </app-text>
                                </div>

                                <v-divider v-if="$vuetify.breakpoint.width > 424" vertical/>
                                
                                <!--In-->
                                <div class="ffrcr-counter" width="20">
                                    <app-text class="grey--text" category="text-small">IN</app-text>
                                    <app-text class="grey--text" category="text-default-bold"> {{ computedUsersSwappedIn }} </app-text>
                                </div>

                                <v-divider vertical/>

                                <!--Out-->
                                <div class="ffrcr-counter" width="20">
                                    <app-text class="grey--text" category="text-small">OUT</app-text>
                                    <app-text class="grey--text" category="text-default-bold"> {{ computedUsersSwappedOut }} </app-text>
                                </div>

                                <v-divider vertical/>

                                <!--Total-->
                                <div class="ffrcr-counter" width="40">
                                    <app-text class="grey--text" category="text-small">TOTAL</app-text>
                                    <app-text class="grey--text" category="text-default-bold"> {{ computedUsersTotal }} </app-text>
                                </div>

                            </div>
                            

                            <!-- //* TITLE-->
                            <v-col class="mt-3 pa-1" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                <v-text-field color="black" :label="$t(`fields.name`)" v-model="form.name" :rules="rules.name" required filled hide-details="auto" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}"></v-text-field>
                            </v-col>

                            <!-- //* TYPE-->
                            <v-col class="mt-3 pa-1" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                <v-text-field color="black" :label="$t(`fields.type`)" v-model="form.type" :rules="rules.type" required filled hide-details="auto" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}"></v-text-field>
                            </v-col>

                            <!-- //* NOTES-->
                            <v-col class="my-2 pa-1" cols="12">
                                <v-textarea color="black" :label="$t(`fields.notes`)" v-model="form.notes"  filled hide-details="auto" rows="3" :background-color="formBackground" auto-grow dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}"></v-textarea>
                            </v-col>

                            <!--Duration-->
                            <!--Small screens only-->
                            <div v-if="$vuetify.breakpoint.smAndDown" class="mt-4">
                                <div>
                                    <app-text category="text-small" class="grey--text">Time Taken</app-text>
                                    <app-text category="text-default" class="grey--text"> {{ computedTimeTaken }} </app-text>
                                </div>
                            </div>

                        </v-row>

                    </v-form>

                    <!--User list-->
                    <div class="frc-userList mx-3 mt-1">
                        <div v-for="user in computedUserList" :key="user.id">
                            <div class="d-flex">
                                <v-icon class="icons8-checkmark-yes mr-2" color="success lighten-2" size="24"/>
                                <app-text category="text-default" class="grey--text">{{ user.userName }}</app-text>
                            </div>
                        </div>
                    </div>

                </v-tab-item>
            </v-tabs-items>

        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: "fireRollCall",
    data: () => ({
        //* PAGE DETAILS   
        collection: 'fireRollCall',
        collectionTitle: 'FireRollCall',
        collectionItem: 'fireRollCall',
        
        errors: {
            title: false,
            type: false,
            notes: false,
        },
        form: {
            id: '',
            name: '',
            site: '',
            type: '',
            notes: '',
            timeTaken: 0,
            checkedUsers: [],

            modifiedDateTime: '',
            modifiedUserData: '',
        },
        swappLogsCollectionData: [],
        usersCollectionData: [],

        formReadOnly: false,
        formMode: 'New',
        formBackground: 'grey lighten-3',
        tabs: '',

        rules: []

    }),
    // * COMPUTED
    computed: {
        ...mapGetters({
            GET_openItem: 'GET_openFireRollCall',
            GET_help: 'GET_help',
                GET_confirmBoxResult: 'confirmBox_store/GET_confirmBoxResult', // Get Confirm Box Result
        }),
        computedUserList() {
            const t = this

            return t.form.checkedUsers.sort((a, b) => {
                return a.userName > b.userName ? 1 : -1
            })
        },
        computedUsersSwappedIn() {
            const t = this

            return t.form.checkedUsers.filter(user => user.swappStatus === 1).length
        },
        computedUsersSwappedOut() {
            const t = this

            return t.form.checkedUsers.filter(user => user.swappStatus === 0).length
        },
        computedUsersTotal() {
            const t = this

            return t.form.checkedUsers.length
        },
        computedTimeTaken() {
            const t = this

            const timeInMillis = new Date(1000 * Math.round(t.form.timeTaken / 1000))
            return `
                ${timeInMillis.getUTCHours()} h :
                ${('0' + timeInMillis.getUTCMinutes()).slice(-2)} m :
                ${('0' + timeInMillis.getUTCSeconds()).slice(-2)} s`
        },
    },
    //* WATCH
    watch: {
            GET_confirmBoxResult: {
                handler: async function() {
                    var t = this;
                    if (t.GET_confirmBoxResult.data.collection === 'fireRollCall') {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var deleteResult = await t.MIX_deleteDocument (t.GET_confirmBoxResult.data.collection, t.GET_confirmBoxResult.data.id);
                            if (deleteResult.code === 1) {
                                t.MIX_alert(1, 'Fire Roll Call Deleted', deleteResult.data, null);
                            } else {
                                t.MIX_alert(-1, 'Error Deleting Fire Roll Call', null, deleteResult.error);
                            }
                        }
                    } else {
                        // Do nothing

                    }
                }, deep: true
            }

    },
    //* METHODS
    methods: {
        ...mapActions({'ACT_openItem': 'ACT_openFireRollCall'}),           
        // UPDATE BREADCRUMBS
        updateBreadcrumbs() {
            var t = this;
            var breadcrumbs = [];
            breadcrumbs.push ({ name: `${t.collectionTitle}`, path: `/${t.collection}`}) // Set the Main Path
            if (t.GET_openItem.process === 'New') {
                breadcrumbs.push ({ name: `New ${t.collectionItemTitle}`, path: `/${t.collection}`}) // Set a Secondary Path
            } else {
                breadcrumbs.push ({ name: `${this.GET_openItem.data[t.collectionItem + 'Name']}`, path: `/${t.collection}/${this.GET_openItem.data.id}`}) // Set a Secondary Path
            }
            this.MIX_breadcrumbs(breadcrumbs);
        },
        // OPEN ITEM (GENERIC)
        openItem: async function() {
            var t = this;
            var openItem = await t.GET_openItem; // Get Open Item Data
            switch (openItem.process) {
                case 'New': 
                    t.formMode = 'New'; // Show Form in New Mode
                    t.formReadOnly = false; // Make Form Editable
                    t.formBackground = 'white'; // Change Background Colour of Form
                    break;
                case 'View': 
                    var item = await t.MIX_readDocumentById('fireRollCall', openItem.data.id)
                    t.form = item.data; // Update the Form with the Open Item details            
                    t.formMode = 'View'; // Show Form in View Mode
                    t.formReadOnly = true; // Make Form Read Only
                    t.formBackground = 'grey lighten-3'; // Change Background Colour of Form
                    break;
                case 'Edit': 
                    var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                    t.form = item.data; // Update the Form with the Open Item details            
                    t.formMode = 'Edit'; // Show Form in Edit Mode
                    t.formReadOnly = false; // Make Form Editable
                    t.formBackground = 'white'; // Change Background Colour of Form
                    break;
            }              
            return;
        },
        closeRightPanel() {
            this.updateBreadcrumbs();
            this.ACT_panelLayout({ leftPanel: 12, rightPanel: 0, show: false, dynamicComponent: '' });
        },
        // EDIT ITEM (GENERIC)
        editItem() {
            var t = this;
            t.formMode = 'Edit';
            t.formReadOnly = false;
            t.formBackground = 'white';
        },
        // CANCEL ITEM (GENERIC)
        cancelItem() {
            var t= this;
            t.formMode = 'View';
            t.formReadOnly = true;
            t.formBackground = 'grey lighten-3';
            t.refreshItemView();    
            t.closeRightPanel();    
        },
        // DELETE ITEM METHOD
        deleteItem: function (id) {
            var t = this;
            t.MIX_confirmBox(
                { 
                    show: true,
                    collection: t.collection,
                    id: id,
                    title: `Delete Fire Roll Call?`, 
                    description: `Are you sure you want to delete Fire Roll Call: <br /><strong>${t.form.name}</strong>?`, 
                    width: '400',
                    height: '200',
                    trueButtonText: 'Yes',
                    trueButtonValue: 'YES',
                    falseButtonText: 'No',
                    falseButtonValue: 'NO',
                }
            )
        },
        // SAVE ITEM (GENERIC)
        saveItem: async function() {
            var t = this;
            if (t.form.id === undefined) {
                t.form.id = t.MIX_generateId();  // if new then generate new id
            }
            var createDocumentResult = await t.MIX_createDocument(t.collection, t.form); // Create Document Within Firestore based on Form
            if (createDocumentResult.code === 1) {
                t.MIX_alert(1, `${t.collectionItemTitle} Saved`, null, null); // Send Success Alert to Item
                t.formMode = 'View'; // Change Form Mode
                t.formReadOnly = true; // Set Form to Read Only
                t.formBackground = 'grey lighten-3';
                t.refreshItemView();
            } else {
                t.MIX_alert(-1, `Error Saving ${t.collectionItemTitle}`, null, null); // Send Error Alert to Item
            }
        },
        // REFRESH ITEM VIEW
        refreshItemView: async function() {
            var t = this;
            var itemResult = await t.MIX_readDocumentById(t.collection, t.form.id)
            var payload = {}
            payload.process = 'View';
            payload.popup = false;
            payload.data = itemResult.data;
            t.ACT_openItem(payload);
            t.openItem();
        },
            // UPDATE ITEM STATUS
        updateItemStatus: async function(status) {
            var t = this;
            var updateResult = await t.MIX_updateDocumentFieldsById (t.collection, t.form.id, { [t.collectionItem + 'Status']: status } )
            if (updateResult.code === 1) {
                t.MIX_alert(1, 'Status Updated', updateResult.data, null);
                t.refreshItemView();
            } else {
                t.MIX_alert(-1, 'ERROR - Could not update Status', null, updateResult.error); 
            }
        },
        // * VALIDATION RULES
		validateForm() {
			let t = this;
            t.rules = {
                name: [ v => !!v || 'Name is required'],
                type: [ v => !!v || 'Type is Required'],
            }
            //let the DOM update
            t.$nextTick(() => {
                //manually trigger Vuetify validation
                if(t.$refs.form.validate()) {     
                    this.saveItem();
                } else {
                    t.MIX_alert(-1, "Please fill out all the fields", null, null);
                }
                //if not valid, errors will be automatically displayed
            })
		},



    },
    async mounted() {
        var t = this;
        //* ITEM RELATED MOUNTED
        var openItem = await t.GET_openItem; // Get open project data
        t.formMode = openItem.process; // Show form in View Mode
        if (openItem.process === 'New') {
            t.formReadOnly = false; // Make form editable
            t.formBackground = 'white';
        } else {
            t.form = openItem.data; // Update the Form with the Open Project Details
            t.formReadOnly = true;
            t.formBackground = 'grey lighten-3';
        }

        // if (openItem.popup === false) { t.updateBreadcrumbs() } // Update Breadcrumbs in Title

    }
}
</script>


<style scoped>
  .disabled >>> .v-input__slot::before {
        border-style: none !important;
    }
.frc-icon {
    border-radius: 50%;
    padding: 8px;
}

.frc-icon-edit-active {
    background: orange;
    border-radius: 50%;
    color: white;
    padding: 8px;
}
.frcr-counter-container {
    display: flex;
    align-self: center;
    justify-content: center;
    grid-gap: 32px;

    background: rgb(238, 238, 238);
    border-radius: 5px;
    margin-top: 16px;
    padding: 8px 16px;
    width: calc(100%);
    z-index: 1;
}

.ffrcr-counter {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.frc-userList {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    grid-gap: 16px;

    background: rgb(238, 238, 238);
    border-radius: 5px;
    margin-top: 16px;
    padding: 16px;
}
</style>
